import { useMutation } from "react-query";
import getPoolingSku from "../services/getPoolingSku";

function usePoolingSku() {
  return useMutation(["pooling-sku"], getPoolingSku);
}

export default usePoolingSku;
